<script>
import Vue from 'vue';
import { BarcodeGeneratorPlugin } from "@syncfusion/ej2-vue-barcode-generator";
Vue.use(BarcodeGeneratorPlugin);
export default {
    name: "PatientDetailsModal",

    data() {

      return {
          active: 0,
          activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
          inActiveClass: `bg-gray-300 border-l border-r border-t`,
          width: "200px",
         height: "150px",
         mode: "SVG",
         type: "Code128A",
         value: "SYNCFUSION",
         patientInsurances: [],
         nextOfKins: [],
         questionaires: [],
      };
    },

    props: {

        showModal: Boolean,
        patient: Object,
    },

    watch: {

      showModal() {
        if(!this.showModal) return;

        this.fetchPatientInsurance();
      },

      active() {

        if(this.active == 1) {

            this.fetchPatientNOKs();
        }

        if(this.active == 2) {

            // this.fetchPatientNOKs();
        }

        if (this.active == 3) {

          this.fetchPatientQuestionaires();
        }

      },
    },

    components: {

      "next-of-kin-tab": () => import('./details-tabs/NextOfKin.vue'),
      "document-management-tab": () => import('./details-tabs/DocumentManagement.vue'),
      "insurance-tab": () => import('./details-tabs/Insurance.vue'),
      "questionnaire-tab": () => import('./details-tabs/Questionaire.vue'),
    },

    methods: {

        fetchPatientInsurance() {
            this.$root.loading = true;
            this.$http.get(`PatientRegistration/GetPatientInsurances?CustomerID=${this.patient.patienT_ID}`).then(response => {
              this.patientInsurances = response.data;
              this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });            
        },

        fetchPatientNOKs() {
            return this.$http.get(`PatientRegistration/GetPatientNextofKins?CustomerID=${this.patient.patienT_ID}`).then(response => {
                this.nextOfKins = response.data;
            }).catch(() => {});
        },

        fetchPatientQuestionaires() {

            return this.$http.get(`PatientRegistration/GetPatientQuestionnaires?PatientID=${this.patient.patienT_ID}`).then(response => {
                this.questionaires = response.data;
            }).catch(() => {});
        },

        printDetails() {
          ///${prefix}/patient-management/print/:patientID
          window.open(
            `/registration/patient-management/print/${this.patient.patienT_ID}`, 
            '_blank', `PatientPreview`, 
            "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        }

    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-3/4 sm:w-10/12 h-auto">
  <template v-slot:title>
    <h5 class="font-bold text-sm">Patient Details</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex md:flex-row sm:flex-col -m-4">
      <div class="sm:w-full md:w-10/12 flex flex-wrap">
        <div class="md:w-1/5 sm:w-1/2 p-1">
          <h5 class="font-semibold text-sm">Patient: <span class="text-blue-800 text-sm">{{ patient.names }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Id No/Passport: </span>
            <span class="font-semibold text-blue-800 text-sm">{{ patient.nationalid || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">IP File No: </span>
            <span class="font-semibold text-blue-800">{{ patient.ipfileno || ' -' }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">OP File No: </span>
            <span class="font-semibold text-blue-800">{{ patient.opfileno || ' -'}}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">DOB: </span>
            <span class="font-semibold text-blue-800">{{ patient.dob | dateFormat }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Gender: </span>
            <span class="font-semibold text-blue-800">{{ patient.gender || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Cellphone: </span>
            <span class="font-semibold text-blue-800">{{patient.celL_PHONE || " -" }}</span></h5>
        </div>
        <div class="md:w-1/5 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Other Cellphone: </span>
            <span class="font-semibold text-blue-800">{{patient.otheR_PHONE || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Employment: </span>
            <span class="font-semibold text-blue-800">{{ patient.employment || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Employer: </span>
            <span class="font-semibold text-blue-800">{{ patient.employer || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Residence: </span>
            <span class="font-semibold text-blue-800">{{ patient.residence || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">County: </span>
            <span class="font-semibold text-blue-800">{{ patient.county || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Location: </span>
            <span class="font-semibold text-blue-800">{{ patient.location || " -" }}</span></h5>
        </div>
        <div class="md:w-1/6 sm:w-1/2 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Sublocation: </span>
            <span class="font-semibold text-blue-800">{{ patient.sublocation || " -" }}</span></h5>
        </div>
      </div>
      <div class="sm:w-full md:w-3/12">
        <ejs-barcodegenerator
          id="barcode"
          invalid="invalidInput"
          ref="barcodeControl"
          :width="width"
          :height="height"
          :type="type"
          :value="patient.patienT_ID"
          :mode="mode"
        ></ejs-barcodegenerator>
      </div>
    </div>
    <div class="flex flex-col content-start mt-5 -mx-3 overflow-auto border-t-2 pt-2 border-gray-500" style="height:40vh;">
      <ul class="w-full flex border-b-2 border-gray-500">
          <li class="-mb-px mr-1">
            <a href="javascript:void(0)" @click.prevent="active=0"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
              :class="active == 0 ? activeClass : inActiveClass">Insurance Details</a>
          </li>
          <li class="-mb-px mr-1">
            <a href="javascript:void(0)" @click.prevent="active=1"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
              :class="active == 1 ? activeClass : inActiveClass">Next of kin</a>
          </li>
          <li class="-mb-px mr-1">
            <a href="javascript:void(0)" @click.prevent="active=2"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
              :class="active == 2 ? activeClass : inActiveClass">Document Management</a>
          </li>
          <li class="-mb-px mr-1">
            <a href="javascript:void(0)" @click.prevent="active=3"
              class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
              :class="active == 3 ? activeClass : inActiveClass">Questionnaire</a>
          </li>
        </ul>
        <div class="w-full" v-if="active==0">
            <insurance-tab 
              :patientInsurances="patientInsurances">
            </insurance-tab>
        </div>
        <div class="w-full" v-if="active==1">
            <next-of-kin-tab
              :nextOfKins="nextOfKins"
            ></next-of-kin-tab>
        </div>
        <div class="w-full" v-if="active==2">
            <document-management-tab
              :patient="patient"
            ></document-management-tab>
        </div>
        <div class="w-full" v-if="active==3">
            <questionnaire-tab 
              :questionaires="questionaires">
            </questionnaire-tab>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
      class="btn-sm btn-primary text-xs rounded mr-8" 
      @click.prevent="printDetails" title="Print">
        <i class="fa fa-print"></i> Print</button>
    <button 
      class="btn-danger btn-sm text-xs rounded" 
      @click.prevent="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>